import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { isStore } from '../Authetication'



export default function StoreRoutes() {


  let auth = {"token": isStore()}

  

  return (
   auth.token ? <Outlet/> : <Navigate to="/dashboard"/>
  )
}
